import { createContext, useContext } from "react";

// interface Props {
//   test?: string;
// }

// export const GameContext = createContext<Props>({});
export const GameContext = createContext<any>({});

export const useGameContext = () => useContext(GameContext);

export const GameProvider = GameContext.Provider;
